import {initializeApp} from 'firebase/app';
import {
    getFirestore,
    disableNetwork,
    collection,
    setDoc,
    doc,
    getDocs,
    getDoc,
    query,
    deleteDoc,
    enableIndexedDbPersistence
} from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCVrbPSDXQvXYCMVGq_oir1IWCYvC4iTLo",
    authDomain: "testing-51739.firebaseapp.com",
    projectId: "testing-51739",
    storageBucket: "testing-51739.appspot.com",
    messagingSenderId: "152577394561",
    appId: "1:152577394561:web:f9c236b1cb48f92a520a80"
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
enableIndexedDbPersistence(db)
    .catch((error) => {
        if (error.code === 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabled in one tab at a time.
            console.error('Multiple tabs open. Offline persistence can only be enabled in one tab at a time.');
        } else if (error.code === 'unimplemented') {
            // The current browser does not support all of the features required to enable persistence.
            console.error('Offline persistence is not supported in this browser.');
        }
    });

export {db, collection, doc, setDoc, getDocs, getDoc, deleteDoc, query, disableNetwork}